export default {seo:{title:'Rechercher un événement',description:null},title:'Rechercher un événement',inputFilter:{quickSearch:'Recherche rapide'}};